import { indentOnInput } from "@codemirror/language";
import { EditorState } from "@codemirror/state";
import { basicSetup } from "codemirror";

// This removes the fold gutter.
const withoutFoldGutter = Array.isArray(basicSetup)
  ? basicSetup.filter((_, i) => i !== 4)
  : [basicSetup];

const withoutHighlightActiveLine = withoutFoldGutter.filter((_, i) => i !== 14);

export const generalSetup = [
  withoutFoldGutter,
  indentOnInput(),
  EditorState.readOnly.of(true),
];

export const debuggerSetup = [
  withoutHighlightActiveLine,
  indentOnInput(),
  EditorState.readOnly.of(true),
];
